import React, { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorPage from '../error-page/error-page';

// Router-level fallback (errorElement). Offline'dayken API yanıtları
// undefined kaldığı için render hataları buraya düşer — bağlantı geri
// gelince sayfayı otomatik yeniler. Görünüm error-page'de; hata detayı
// kullanıcıya gösterilmez, yalnız console'a yazılır.
const RouteError = () => {
  const error = useRouteError();
  const [isOffline, setIsOffline] = useState(
    typeof navigator !== 'undefined' && !navigator.onLine,
  );

  useEffect(() => {
    if (error) console.error('[RouteError]', error);
  }, [error]);

  useEffect(() => {
    const onOnline = () => window.location.reload();
    const onOffline = () => setIsOffline(true);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return (
    <ErrorPage
      variant={isOffline ? 'offline' : 'error'}
      onRetry={() => window.location.reload()}
    />
  );
};

export default RouteError;
